/*!

=========================================================
* Vue Argon Design System - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system/blob/master/LICENSE.md)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Argon from "./plugins/argon-kit";
import './registerServiceWorker';
import SmartTable from 'vuejs-smart-table';
import { registerLicense } from '@syncfusion/ej2-base';
// import "../node_modules/@syncfusion/ej2/bootstrap5.css"

// Registering Syncfusion license key
registerLicense('Ngo9BigBOggjHTQxAR8/V1NAaF5cWWVCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWX5ccXRcRmleVEZ0Wks=');


Vue.config.productionTip = false;

Vue.use(SmartTable);
Vue.use(Argon);
new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
